const getBreakpointValue = (value, breakpoint) => {
  const regExp = new RegExp(`\\b${breakpoint}:[^\\s]+\\b`);
  const match = value.match(regExp);
  return match ? match[0].split(':')[1] : null;
};

export default getBreakpointValue;
